var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('list-indicator',{attrs:{"rows":_vm.rows,"list-entity-type":_vm.listEntityType},scopedSlots:_vm._u([{key:"listView_cell_preTaxAmount",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.currency(item.row.preTaxAmount))+" ")]}},{key:"listView_cell_totalAmount",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.currency(item.row.totalAmount))+" ")]}},{key:"listView_cell_balance",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.currency(item.row.balance))+" ")]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }